import { deals } from './deals'
import { dealTemplates } from './deal-templates'
import { signatures } from './signatures'
import { users } from './users'
import { auth } from './auth'
import { organizations } from './organizations'
import { oauth } from './oauth'
import { admin } from './admin'
import { closingBooks } from './closing-books'
import { pusher } from './pusher'
import { upload } from './upload'
import { agenda } from './agenda'
import { tokens } from './tokens'
import { trash } from './trash'
import { items } from './items'
import { actionItems } from './action-items'
import { agendaNotes } from './agenda-notes'
import { approvals } from './approvals'
import { itemVariables } from './item-variables'
import { versions } from './versions'
import { closingVersions } from './closing-versions'
import { firms } from './firms'
import { agendaColumnEntries } from './agenda-column-entries'
import { dealFields } from './deal-fields'
import { fileMatches } from './file-matches'
import { markups } from './markups'
import { schedules } from './schedules'
import { snapshots } from './snapshots'
import { blacklines } from './blacklines'

export type ClofoApiErrorParams = {
  method: string
  endpoint: string
  url: string
  status: number
  statusText?: string
  errorCode?: string
  errorData?: unknown
}
export class ClofoApiError extends Error {
  public readonly method: string
  public readonly endpoint: string
  public readonly url: string
  public readonly status: number
  public readonly errorCode: string
  public readonly statusText?: string
  public readonly errorData?: unknown

  constructor({
    method,
    endpoint,
    url,
    status,
    statusText,
    errorCode,
    errorData,
  }: ClofoApiErrorParams) {
    const codeText = errorCode ? ` ${errorCode}` : statusText ? ` ${statusText}` : ''
    const message = `${method.toUpperCase()} ${endpoint} (${status}${codeText})`
    super(message)

    this.name = 'ClofoApiError'
    this.method = method
    this.endpoint = endpoint
    this.url = url
    this.status = status
    this.statusText = statusText
    this.errorCode = errorCode || ''
    this.errorData = errorData
  }
}

export const clofoApi = {
  deals,
  dealTemplates,
  signatures,
  users,
  auth,
  organizations,
  oauth,
  admin,
  closingBooks,
  pusher,
  upload,
  agenda,
  tokens,
  trash,
  items,
  actionItems,
  agendaNotes,
  approvals,
  itemVariables,
  versions,
  closingVersions,
  firms,
  agendaColumnEntries,
  dealFields,
  fileMatches,
  markups,
  schedules,
  snapshots,
  blacklines,
}
